import { styled } from '@mui/material';

import { StyledIcon } from '../StyledIcon';

const StyledSearchIcon = styled(StyledIcon)`
  padding-top: 0.2rem;
`;

export function SearchIcon(props) {
  const { size = 17, color, className } = props;

  return (
    <StyledSearchIcon color={color}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 17 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
      >
        <circle
          width={size}
          height={size}
          cx='7.98438'
          cy='7.5'
          r='6.5'
          stroke='currentColor'
        />
        <path
          width={size}
          height={size}
          d='M16.4844 16L12.4893 11.995'
          stroke='currentColor'
        />
      </svg>
    </StyledSearchIcon>
  );
}
